import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  FeatureConfigSelectors,
  FeatureConfigState,
} from '@common/data-access-feature-config';
import { JourneyType } from '@common/util-models';
import { Store } from '@ngrx/store';
import { first, map, Observable, of, tap } from 'rxjs';

const STORE_QUERY_KEY = 'store=';

@Injectable()
export class JourneyTypeGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly store: Store<FeatureConfigState>
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return state.url.includes(STORE_QUERY_KEY)
      ? this.store.select(FeatureConfigSelectors.getConfigJourneyType).pipe(
          first(),
          tap(this.redirectIfMobileJourney.bind(this)),
          map(() => true)
        )
      : of(true);
  }

  private redirectIfMobileJourney(journeyType: JourneyType): void {
    if (
      journeyType === JourneyType.Mobile ||
      journeyType === JourneyType.MobileVip
    ) {
      this.router.navigate(['/add-mobile']);
    }
  }
}
